import { Partner } from './subscriptions.types';

export const PARTNER_TITLE: Record<Partner, string> = {
    'ru.mail.special': 'VK\u00A0Combo',
    rostelecom: 'Ростелеком',
    tele2: 'Tele2',
    megafon: 'Мегафон',
};

export const PARTNER_LIST = Object.keys(PARTNER_TITLE);
